import React from 'react'
import styled from 'styled-components'
import { interactiveText } from './styled'
import Icon from '../../images/magic/gradient-arrow.svg'
import { Link } from 'gatsby'

const LinkStyled = styled(Link)`
  text-decoration: none;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  align-items: center;
  ${interactiveText};

  &:hover {
    opacity: 0.8;
  }
`

const ArrowIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  margin-left: 12px;
`

const GradientLink = ({ title, url }) => {
  const isExternal = url.includes('https')

  const props = isExternal
    ? {
        href: url,
        as: 'a',
      }
    : {
        to: url,
      }

  return (
    <LinkStyled {...props}>
      <span>{title}</span>
      <ArrowIcon />
    </LinkStyled>
  )
}

export default GradientLink
